/* eslint-disable no-restricted-globals */
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { withEdit } from '../Context';
import { Column, Columns } from '../components';
import { withComponents } from '../components/Context';
import ResizableIframe from '../components/ResizableIframe';
import { replaceUrlValues } from '../utils';
import BaseSection from './BaseSection';
import './iframe-section.scss';
import { generateIframeUrl } from '../utils/urlUtils';

class IFrameSection extends PureComponent {
  renderContents() {
    const {
      source,
      iframe,
      iframePosition,
      columnsSize,
      text,
      components,
      hasAutoResize,
      urlType,
    } = this.props;
    const url = replaceUrlValues(generateIframeUrl(source, urlType));

    const { RichText } = components;

    // iframe key used to force refresh iframe/reload when url or hasAutoResize changes
    const iframeEl = (
      <ResizableIframe
        src={url}
        autoResize={hasAutoResize}
        allowFullScreen
        allow="camera *;microphone *;fullscreen *;display-capture *"
        {...iframe}
      />
    );

    if (iframePosition === 'fullpage') return iframeEl;

    // Else left/right
    return (
      <Columns isCentered centerVertically>
        {iframePosition === 'left' && <Column className={columnsSize}>{iframeEl}</Column>}
        <Column>
          <RichText html={text} name="text" placeholder="Texte" />
        </Column>
        {iframePosition === 'right' && <Column className={columnsSize}>{iframeEl}</Column>}
      </Columns>
    );
  }

  render() {
    const { source, iframe, iframePosition, ...props } = this.props;

    return (
      <BaseSection {...props} block={this.props}>
        {!source && (
          <div style={{ padding: 32 }}>
            Paramétrez l'url du formulaire dans les options de droite
          </div>
        )}
        {this.renderContents()}
      </BaseSection>
    );
  }
}

IFrameSection.defaultProps = {
  columnsSize: 'is-half',
  source: '',
  iframePosition: 'fullpage',
  hasAutoResize: true,
  iframe: {},
  isPreview: false,
  text: '',
  urlType: undefined,
};

IFrameSection.propTypes = {
  columnsSize: PropTypes.string,
  hasAutoResize: PropTypes.bool,
  components: PropTypes.shape({
    RichText: PropTypes.elementType,
  }).isRequired,
  iframe: PropTypes.shape({
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  iframePosition: PropTypes.oneOf(['left', 'right', 'fullpage']),
  isPreview: PropTypes.bool,
  source: PropTypes.string,
  text: PropTypes.string,
  urlType: PropTypes.oneOf(['registration', 'appcraft']),
};

export default withEdit(withComponents(IFrameSection));
